export const EMAIL_REGEX = "[\\w\\-\\.]+@([\\w\\-]+\\.)+[\\w\\-]{2,}";
export const FEEDBACK_TITLE_CHARACTER_LIMIT = process.env.FEEDBACK_TITLE_CHARACTER_LIMIT
    ? parseInt(process.env.FEEDBACK_TITLE_CHARACTER_LIMIT)
    : Number.MAX_SAFE_INTEGER;
//export const FEEDBACK_TITLE_CHARACTER_LIMIT = 5;
export const FEEDBACK_DESCRIPTION_CHARACTER_LIMIT = process.env.FEEDBACK_DESCRIPTION_CHARACTER_LIMIT
    ? parseInt(process.env.FEEDBACK_DESCRIPTION_CHARACTER_LIMIT)
    : Number.MAX_SAFE_INTEGER;
